import { hbarGap, hbarSize } from '../theme/layout';

interface HorizontalBarProps {
  spacing?: 'none' | 'xs' | 'sm' | 'base' | 'lg' | 'xl';
  size?: 'sm' | 'base' | 'lg';
  color?: 'light-gray' | 'dark-gray';
}

const bgColor = {
  'light-gray': 'bg-[#313131]',
  'dark-gray': 'bg-[#232222]',
};

export default function HorizontalBar(props: HorizontalBarProps) {
  const { spacing, size, color } = props;

  return (
    <div
      className={`${hbarSize[size || 'sm']} w-full ${
        bgColor[color || 'dark-gray']
      } rounded-md ${hbarGap[spacing || 'none']}`}
    ></div>
  );
}
